<mat-card>
  <h2 translate>help.title</h2>
  <mat-card-content>
    <p translate>help.subtitle</p>
  </mat-card-content>
</mat-card>
<mat-tab-group color="accent">
  <mat-tab [label]="'legend.title' | translate | uppercase">
    <mat-card>
      <h2 translate>legend.card.title</h2>
      <mat-card-content>
        <p class="legend__subtitle" translate>legend.card.subtitle</p>
        <div class="legend__content-row">
          <button mat-stroked-button class="legend__row-button">
            <mat-icon class="icon-ic_file_download"></mat-icon>
          </button>
          <mat-label [innerHTML]="'legend.card.download' | translate"></mat-label>
        </div>
        <div class="legend__content-row">
          <button mat-stroked-button class="legend__row-button">
            <mat-icon class="icon-ic_print"></mat-icon>
          </button>
          <mat-label [innerHTML]="'legend.card.print' | translate"></mat-label>
        </div>
        <div class="legend__content-row">
          <button mat-stroked-button class="legend__row-button">
            <mat-icon class="icon-ic_visibility"></mat-icon>
          </button>
          <mat-label [innerHTML]="'legend.card.view' | translate"></mat-label>
        </div>
        <div class="legend__content-row">
          <button mat-stroked-button class="legend__row-button legend__row-button--blue">
            <mat-icon class="icon-ic_postit"></mat-icon>
          </button>
          <mat-label [innerHTML]="'legend.card.notes' | translate"></mat-label>
        </div>
        <div class="legend__content-row">
          <button mat-button class="legend__row-button">
            <mat-icon class="icon-ic_document legend__icon"></mat-icon>
          </button>
          <mat-label [innerHTML]="'legend.card.pdf' | translate"></mat-label>
        </div>
        <div class="legend__content-row">
          <button mat-button class="legend__row-button">
            <mat-icon class="icon-ic_pdf_scf legend__icon"></mat-icon>
          </button>
          <mat-label [innerHTML]="'legend.card.edit' | translate"></mat-label>
        </div>
        <div class="legend__content-row">
          <button mat-button class="legend__row-button">
            <mat-icon class="icon-ic_ine legend__icon"></mat-icon>
          </button>
          <mat-label [innerHTML]="'legend.card.ine' | translate"></mat-label>
        </div>
        <div class="legend__content-row">
          <button mat-button class="legend__row-button">
            <mat-icon class="icon-ic_sign legend__icon"></mat-icon>
          </button>
          <mat-label [innerHTML]="'legend.card.sign' | translate"></mat-label>
        </div>
        <div class="legend__content-row">
          <button mat-button class="legend__row-button">
            <mat-icon class="icon-ic_clip-bold legend__icon"></mat-icon>
          </button>
          <mat-label [innerHTML]="'legend.card.attach' | translate"></mat-label>
        </div>
        <div class="legend__content-row">
          <button mat-stroked-button class="legend__row-button">
            <mat-icon class="icon-ic_payment-sheet"></mat-icon>
          </button>
          <mat-label [innerHTML]="'legend.card.payment' | translate"></mat-label>
        </div>
        <div class="legend__content-row">
          <button mat-button class="legend__row-button legend__row-button--yellow">
            <mat-icon class="icon-ic_warning legend__icon"></mat-icon>
          </button>
          <mat-label [innerHTML]="'legend.card.warning' | translate"></mat-label>
        </div>
      </mat-card-content>
    </mat-card>
  </mat-tab>
  <mat-tab [label]="'faqs.title' | translate">
    <mat-card class="faqs__content-card">
      <mat-card-title>INE</mat-card-title>
      <mat-card-content>
        <mat-accordion>
          <mat-expansion-panel
            #panel1
            hideToggle
            (opened)="setClassIcon(panel1, icon1)"
            (closed)="setClassIcon(panel1, icon1)"
          >
            <mat-expansion-panel-header #header1 [collapsedHeight]="expandedHeight" [expandedHeight]="expandedHeight">
              <mat-panel-title translate>faqs.ine.question</mat-panel-title>
              <mat-panel-description>
                <mat-icon #icon1 [class]="iconClassOpen"></mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="faqs__container">
              <p class="faqs__subtitle" translate>
                faqs.ine.answer.icon <mat-icon id="formationDocumentationPDFIcon" class="icon-ic_document"></mat-icon>
              </p>
              <p class="faqs__subtitle" translate>faqs.ine.answer</p>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel
            #panel2
            hideToggle
            (opened)="setClassIcon(panel2, icon2)"
            (closed)="setClassIcon(panel2, icon2)"
          >
            <mat-expansion-panel-header #header2 [collapsedHeight]="expandedHeight" [expandedHeight]="expandedHeight">
              <mat-panel-title translate>faqs.sms.question</mat-panel-title>
              <mat-panel-description>
                <mat-icon #icon2 [class]="iconClassOpen"></mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="faqs__container">
              <p class="faqs__subtitle" translate>faqs.sms.answer.opt</p>
              <p class="faqs__subtitle" translate>faqs.sms.answer.opt.one</p>
              <p class="faqs__subtitle" translate>faqs.sms.answer.opt.two</p>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel
            #panel3
            hideToggle
            (opened)="setClassIcon(panel3, icon3)"
            (closed)="setClassIcon(panel3, icon3)"
          >
            <mat-expansion-panel-header #header3 [collapsedHeight]="expandedHeight" [expandedHeight]="expandedHeight">
              <mat-panel-title translate>faqs.sign.ine.question</mat-panel-title>
              <mat-panel-description>
                <mat-icon #icon3 [class]="iconClassOpen"></mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="faqs__container">
              <p class="faqs__subtitle" translate>faqs.sign.ine.answer.par.one</p>
              <p class="faqs__subtitle" translate>faqs.sign.ine.answer.par.two</p>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel
            #panel4
            hideToggle
            (opened)="setClassIcon(panel4, icon4)"
            (closed)="setClassIcon(panel4, icon4)"
          >
            <mat-expansion-panel-header #header4 [collapsedHeight]="expandedHeight" [expandedHeight]="expandedHeight">
              <mat-panel-title translate>faqs.ine.sms.question</mat-panel-title>
              <mat-panel-description>
                <mat-icon #icon4 [class]="iconClassOpen"></mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="faqs__container">
              <p class="faqs__subtitle" translate>faqs.ine.sms.answer</p>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel
            #panel5
            hideToggle
            (opened)="setClassIcon(panel5, icon5)"
            (closed)="setClassIcon(panel5, icon5)"
          >
            <mat-expansion-panel-header #header5 [collapsedHeight]="expandedHeight" [expandedHeight]="expandedHeight">
              <mat-panel-title translate>faqs.no.sms.question</mat-panel-title>
              <mat-panel-description>
                <mat-icon #icon5 [class]="iconClassOpen"></mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="faqs__container">
              <p class="faqs__subtitle" translate>faqs.no.sms.answer</p>
              <ul>
                <li translate>faqs.no.sms.answer.opt.one</li>
                <li translate>faqs.no.sms.answer.opt.two</li>
              </ul>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel
            #panel6
            hideToggle
            (opened)="setClassIcon(panel6, icon6)"
            (closed)="setClassIcon(panel6, icon6)"
          >
            <mat-expansion-panel-header #header6 [collapsedHeight]="expandedHeight" [expandedHeight]="expandedHeight">
              <mat-panel-title translate>faqs.mobile.question</mat-panel-title>
              <mat-panel-description>
                <mat-icon #icon6 [class]="iconClassOpen"></mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="faqs__container">
              <p class="faqs__subtitle" translate>faqs.mobile.answer</p>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel
            #panel6
            hideToggle
            (opened)="setClassIcon(panel6, icon6)"
            (closed)="setClassIcon(panel6, icon6)"
          >
            <mat-expansion-panel-header #header6 [collapsedHeight]="expandedHeight" [expandedHeight]="expandedHeight">
              <mat-panel-title translate>faqs.mobile.all.accept.question</mat-panel-title>
              <mat-panel-description>
                <mat-icon #icon5 [class]="iconClassOpen"></mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="faqs__container">
              <div class="faqs__subtitle">
                <div translate>
                  faqs.mobile.all.accept.answer.par.one
                  <mat-icon id="formationDocumentationPDFIcon" class="icon-ic_document"></mat-icon>
                  faqs.mobile.all.accept.answer.par.two
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-card-content>
    </mat-card>
  </mat-tab>
</mat-tab-group>
